import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';
import {
  Users,
  User,
  Mail,
  Phone,
  MapPin,
  FileSpreadsheet,
  PenTool,
  Building2,
  CheckCircle,
  AlertCircle
} from 'lucide-react';

const ModalUploadTenantsForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;
    const [companyID] = useState(1);
    const [location] = useState('');
    const [houses, setHouses] = useState([]);
  const [uploadMethod, setUploadMethod] = useState('');
  const [businessLocations, setBusinessLocations] = useState([]);
  const [tenantsData, setTenantsData] = useState({
    tenantLastName: '',
    tenantFirstName: '',
    tenantGender: '',
    tenantPhone: '',
    tenantEmail: '',
    tenantNationality: '',
    tenantNRC: '',
    houseNumber: '',
    business_locationIDTenants: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [fileData, setFileData] = useState(null);

  useEffect(() => {
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationHousesOnUploadForm');
    formData.append("companyID", companyID);
    formData.append("location", location);
    
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setBusinessLocations(response.data);
      })
      .catch(error => {
        setError("Failed to load business locations");
      });
  }, []);

  useEffect(() => {
    const formData = new FormData();
    formData.append("apiType", 'getHousesOnUploadForm');
    formData.append("businessLocationID", location);
    
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setHouses(response.data);
      })
      .catch(error => {
        setError("Failed to load houses");
      });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTenantsData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFileData(e.target.files[0]);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    const formData = new FormData();
    for (const key in tenantsData) {
      formData.append(key, tenantsData[key]);
    }
    formData.append('companyID', companyID);
    formData.append('businessLocationID', location);
    formData.append('apiType', 'registerTenants');
    
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setLoading(false);
        if (response.data === 'Successful') {
          setSuccess(true);
          setTenantsData({
            tenantLastName: '',
            tenantFirstName: '',
            tenantGender: '',
            tenantPhone: '',
            tenantEmail: '',
            tenantNationality: '',
            tenantNRC: '',
            houseNumber: '',
            business_locationIDTenants: ''
          });
          setTimeout(() => setSuccess(false), 3000);
        } else if (response.data === 'Failed') {
          setError('Failed to upload. Contact support team');
        } else if (response.data === 'Duplicate') {
          setError('Duplicate entry found');
        }
      })
      .catch(error => {
        setLoading(false);
        setError('Network error. Please check your internet connection.');
      });
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    const formData = new FormData();
    formData.append('excelTenants', fileData);
    formData.append('companyID', companyID);
    formData.append('businessLocationID', location);
    formData.append('apiType', 'registerTenantsExcel');

    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setLoading(false);
        if (response.data === 'Upload Completed Successfully' || response.data === '') {
          setSuccess(true);
          setFileData(null);
          setTimeout(() => setSuccess(false), 3000);
        } else {
          setError(response.data);
        }
      })
      .catch(error => {
        setLoading(false);
        setError('Network error. Please check your internet connection.');
      });
  };

  return (
    <>
      <Header />
      <main className="lg:ml-64 pt-16 min-h-screen bg-gray-50">
        <div className="p-6">
          <div className="max-w-6xl mx-auto">
            <div className="mb-8">
              <div className="flex items-center space-x-4 mb-2">
                <div className="p-3 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">Register Tenants</h1>
                  <p className="text-gray-600">Add new tenants or bulk upload via Excel</p>
                </div>
              </div>
            </div>

            {/* Status Messages */}
            {success && (
              <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl">
                <div className="flex items-center space-x-3">
                  <CheckCircle className="w-5 h-5 text-green-600" />
                  <span className="text-green-800 font-medium">Tenant registered successfully!</span>
                </div>
              </div>
            )}

            {error && (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
                <div className="flex items-center space-x-3">
                  <AlertCircle className="w-5 h-5 text-red-600" />
                  <span className="text-red-800 font-medium">{error}</span>
                </div>
              </div>
            )}

            <div className="bg-white rounded-2xl shadow-lg p-6">
              <div className="mb-8">
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Select Upload Method
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <button
                    onClick={() => setUploadMethod('Single Form')}
                    className={`p-4 rounded-xl border-2 transition-all ${uploadMethod === 'Single Form' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`}
                  >
                    <div className="flex items-center space-x-3">
                      <PenTool className="w-5 h-5 text-blue-600" />
                      <div className="text-left">
                        <p className="font-medium text-gray-900">Single Form</p>
                        <p className="text-sm text-gray-500">Register one tenant at a time</p>
                      </div>
                    </div>
                  </button>
                  
                  <button
                    onClick={() => setUploadMethod('Upload Excel File')}
                    className={`p-4 rounded-xl border-2 transition-all ${uploadMethod === 'Upload Excel File' ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`}
                  >
                    <div className="flex items-center space-x-3">
                      <FileSpreadsheet className="w-5 h-5 text-green-600" />
                      <div className="text-left">
                        <p className="font-medium text-gray-900">Excel Upload</p>
                        <p className="text-sm text-gray-500">Bulk upload via Excel file</p>
                      </div>
                    </div>
                  </button>
                </div>
              </div>

              {uploadMethod === 'Upload Excel File' && (
                <form onSubmit={handleFileUpload} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Business Location
                    </label>
                    <select
                      className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                      value={tenantsData.business_locationIDTenantsExcel}
                      onChange={handleInputChange}
                      name="business_locationIDTenantsExcel"
                      required
                    >
                      <option value="">Select Business Location</option>
                      {businessLocations.map(location => (
                        <option key={location.businessLocationID} value={location.businessLocationID}>
                          {location.businessLocationName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Excel File
                    </label>
                    <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-blue-400 transition-colors">
                      <FileSpreadsheet className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                      <p className="text-gray-600 mb-2">Drag & drop your Excel file here</p>
                      <p className="text-sm text-gray-500 mb-4">or</p>
                      <input
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                      />
                      {fileData && (
                        <div className="mt-4 p-3 bg-green-50 rounded-lg">
                          <p className="text-green-800 font-medium">Selected: {fileData.name}</p>
                        </div>
                      )}
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading || !fileData || !tenantsData.business_locationIDTenantsExcel}
                    className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3 px-6 rounded-xl font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                  >
                    {loading ? 'Uploading...' : 'Upload Tenants'}
                  </button>
                </form>
              )}

              {uploadMethod === 'Single Form' && (
                <form onSubmit={handleFormSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <MapPin className="w-4 h-4 inline mr-2" />
                        Business Location
                      </label>
                      <select
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                        value={tenantsData.business_locationIDTenants}
                        onChange={handleInputChange}
                        name="business_locationIDTenants"
                      >
                        <option value="">Select Business Location</option>
                        {businessLocations.map(location => (
                          <option key={location.businessLocationID} value={location.businessLocationID}>
                            {location.businessLocationName}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <Building2 className="w-4 h-4 inline mr-2" />
                        House Assignment
                      </label>
                      <select
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                        value={tenantsData.houseNumber}
                        onChange={handleInputChange}
                        name="houseNumber"
                        required
                      >
                        <option value="">Select House</option>
                        {houses.map(house => (
                          <option key={house.rentalsID} value={house.rentalsID}>
                            Block {house.block} - House {house.houseNumber} (ZMW {house.rentalPrice})
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <User className="w-4 h-4 inline mr-2" />
                        First Name
                      </label>
                      <input
                        type="text"
                        name="tenantFirstName"
                        value={tenantsData.tenantFirstName}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter first name"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <User className="w-4 h-4 inline mr-2" />
                        Last Name
                      </label>
                      <input
                        type="text"
                        name="tenantLastName"
                        value={tenantsData.tenantLastName}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter last name"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <Phone className="w-4 h-4 inline mr-2" />
                        Phone Number
                      </label>
                      <input
                        type="text"
                        name="tenantPhone"
                        value={tenantsData.tenantPhone}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter phone number"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <Mail className="w-4 h-4 inline mr-2" />
                        Email Address
                      </label>
                      <input
                        type="email"
                        name="tenantEmail"
                        value={tenantsData.tenantEmail}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter email address"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Gender
                      </label>
                      <select
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                        value={tenantsData.tenantGender}
                        onChange={handleInputChange}
                        name="tenantGender"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Nationality
                      </label>
                      <input
                        type="text"
                        name="tenantNationality"
                        value={tenantsData.tenantNationality}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter nationality"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        NRC Number
                      </label>
                      <input
                        type="text"
                        name="tenantNRC"
                        value={tenantsData.tenantNRC}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Enter NRC number"
                      />
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading || !tenantsData.tenantFirstName || !tenantsData.tenantLastName || 
                             !tenantsData.tenantPhone || !tenantsData.tenantEmail || 
                             !tenantsData.tenantGender || !tenantsData.business_locationIDTenants || !tenantsData.houseNumber}
                    className="w-full bg-gradient-to-r from-purple-500 to-pink-600 text-white py-3 px-6 rounded-xl font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                  >
                    {loading ? 'Registering...' : 'Register Tenant'}
                  </button>
                </form>
              )}

              {!uploadMethod && (
                <div className="text-center py-12">
                  <Users className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Select an upload method</h3>
                  <p className="text-gray-500">Choose between single form or Excel upload to get started</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ModalUploadTenantsForm;